/** Impls dos use cases comerciais (S2). @since S2 */
import type {
  GrupoVenda, UpsertGrupoVendaCommand,
  LinkCaptacao, UpsertLinkCaptacaoCommand,
  ProcessoSeletivo, UpsertProcessoSeletivoCommand,
  Inscricao, CriarInscricaoCommand,
} from '@/domain/model/ComercialGaps';
import type {
  GrupoVendaGateway, LinkCaptacaoGateway, ProcessoSeletivoGateway,
} from '@/application/port/out/ComercialGapsGateways';
import type {
  ListGruposVendaUseCase, CreateGrupoVendaUseCase, UpdateGrupoVendaUseCase, RemoveGrupoVendaUseCase,
  ListLinksCaptacaoUseCase, CreateLinkCaptacaoUseCase, UpdateLinkCaptacaoUseCase, RemoveLinkCaptacaoUseCase,
  ListProcessosSeletivosUseCase, CreateProcessoSeletivoUseCase, UpdateProcessoSeletivoUseCase,
  AbrirProcessoSeletivoUseCase, EncerrarProcessoSeletivoUseCase, RemoveProcessoSeletivoUseCase,
  ListInscricoesUseCase, CriarInscricaoUseCase, AprovarInscricaoUseCase, ReprovarInscricaoUseCase,
} from '@/application/port/in/ComercialGapsUseCase';

export class ListGruposVenda implements ListGruposVendaUseCase {
  constructor(private readonly g: GrupoVendaGateway) {}
  execute(): Promise<GrupoVenda[]> { return this.g.list(); }
}
export class CreateGrupoVenda implements CreateGrupoVendaUseCase {
  constructor(private readonly g: GrupoVendaGateway) {}
  execute(cmd: UpsertGrupoVendaCommand): Promise<GrupoVenda> { return this.g.create(cmd); }
}
export class UpdateGrupoVenda implements UpdateGrupoVendaUseCase {
  constructor(private readonly g: GrupoVendaGateway) {}
  execute(id: string, cmd: UpsertGrupoVendaCommand): Promise<GrupoVenda> { return this.g.update(id, cmd); }
}
export class RemoveGrupoVenda implements RemoveGrupoVendaUseCase {
  constructor(private readonly g: GrupoVendaGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}

export class ListLinksCaptacao implements ListLinksCaptacaoUseCase {
  constructor(private readonly g: LinkCaptacaoGateway) {}
  execute(): Promise<LinkCaptacao[]> { return this.g.list(); }
}
export class CreateLinkCaptacao implements CreateLinkCaptacaoUseCase {
  constructor(private readonly g: LinkCaptacaoGateway) {}
  execute(cmd: UpsertLinkCaptacaoCommand): Promise<LinkCaptacao> { return this.g.create(cmd); }
}
export class UpdateLinkCaptacao implements UpdateLinkCaptacaoUseCase {
  constructor(private readonly g: LinkCaptacaoGateway) {}
  execute(id: string, cmd: UpsertLinkCaptacaoCommand): Promise<LinkCaptacao> { return this.g.update(id, cmd); }
}
export class RemoveLinkCaptacao implements RemoveLinkCaptacaoUseCase {
  constructor(private readonly g: LinkCaptacaoGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}

export class ListProcessosSeletivos implements ListProcessosSeletivosUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(): Promise<ProcessoSeletivo[]> { return this.g.list(); }
}
export class CreateProcessoSeletivo implements CreateProcessoSeletivoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(cmd: UpsertProcessoSeletivoCommand): Promise<ProcessoSeletivo> { return this.g.create(cmd); }
}
export class UpdateProcessoSeletivo implements UpdateProcessoSeletivoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string, cmd: UpsertProcessoSeletivoCommand): Promise<ProcessoSeletivo> { return this.g.update(id, cmd); }
}
export class AbrirProcessoSeletivo implements AbrirProcessoSeletivoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string): Promise<ProcessoSeletivo> { return this.g.abrir(id); }
}
export class EncerrarProcessoSeletivo implements EncerrarProcessoSeletivoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string): Promise<ProcessoSeletivo> { return this.g.encerrar(id); }
}
export class RemoveProcessoSeletivo implements RemoveProcessoSeletivoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
export class ListInscricoes implements ListInscricoesUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string): Promise<Inscricao[]> { return this.g.listInscricoes(id); }
}
export class CriarInscricao implements CriarInscricaoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(id: string, cmd: CriarInscricaoCommand): Promise<Inscricao> { return this.g.criarInscricao(id, cmd); }
}
export class AprovarInscricao implements AprovarInscricaoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(inscricaoId: string): Promise<Inscricao> { return this.g.aprovarInscricao(inscricaoId); }
}
export class ReprovarInscricao implements ReprovarInscricaoUseCase {
  constructor(private readonly g: ProcessoSeletivoGateway) {}
  execute(inscricaoId: string): Promise<Inscricao> { return this.g.reprovarInscricao(inscricaoId); }
}
